module.exports = __webpack_public_path__ + "static/preview-fib-187f656261cc40a4e829fc78ad7ea94e.png";